module.exports = __webpack_public_path__ + "static/media/disabled-marker.ec8b94fc.webp";